const skillSets = [
  "Rust",
  "Solidity",
  "TS",
  "Python",
  "EVM",
  "Solana",
  "Ethereum",
  "Bitcoin",
  "Web3",
  "React.Js",
  "Next.Js",
  "MUI",
  "Tailwind",
  "Node.Js",
  "Nest.Js",
  "Express",
  "GraphQL",
  "REST API",
  "PstgSQL",
  "MongoDB",
  "MySQL",
  "Redis",
  "Prisma",
  "Docker",
  "AWS",
  "Azure",
  "Firebase",
  "CI/CD",
  "Android",
  "iOS",
  "DeFi",
  "DApp",
  "DEX",
  "NFT",
  "DAO",
  "P2E",
  "Polymarket",
  "Kalshi",
  "Prediction Markets",
  "Trading Bots",
  "Arbitrage",
];

const knowledgeSets = [
  "Smart Contracts",
  "DeFi Protocols",
  "NFT Marketplaces",
  "Token Standards",
  "DAO Governance",
  "DEX Integration",
  "MEV Optimization",
  "Polymarket API",
  "Kalshi API",
  "Prediction Market Strategies",
  "DevOps",
  "CI/CD Pipeline",
  "AWS",
  "Azure",
  "Agile Methodology",
  "Modern Design",
  "Database Optimization",
  "API Design",
];

export { skillSets, knowledgeSets };
